//我的挂牌林权详情
<template>
  <div v-loading="Loading">
    <header-img :list="headerList"></header-img>
    <el-container v-if="status< 3">
      <el-aside width="236px" v-if="leftBanner.length">
        <div :class="{ active: index == chooseIndex }"
          v-for="(item, index) in leftBanner" :key="index"
          @click="leftBannerEvt(item, index)"
        > {{ item }}</div>
      </el-aside>
      <el-main class="main-block">
        <div class="top-title">我的挂牌</div>
        <div  class="status-wrap"  v-if="status == 1 || status == 2"
          :class="status == 1 ? 'checkingBg' : 'checkErrorBg'" >
          <div class="left">
            <div class="img-warp" :class="status == 1 ? 'checking' : 'checkError'" >
              <img :src="statusImg" alt="" />
            </div>
            <div class="status">
              申请状态<br />
              <p v-if="status == 1" style="color:#FFAA36;">{{statusCheck(status)}}</p>
              <p v-if="status == 2">
                <span style="color:#EF5147 ;">{{statusCheck(status)}}</span>
                <span class="errorFont">请修改后再次提交审核</span><br />
                <span style="font-size: 12px;" v-if="formData.reason">不通过原因：{{formData.reason}}</span>
              </p>
            </div>
          </div>
        </div>
        <el-form class="form" ref="formRef" :model="formData" :rules="rules"  label-width="150px"  label-position="left"  size="mini">
          <div id="0">
            <div class="h_bg p50">
              <h3>标的信息</h3>
              <span v-if="!inputDisabled">带“<span class="redF xing">*</span>”号为必填项</span>
            </div>
            <div class="m50">
              <el-form-item label="项目名称" prop="name" :class="{'itemError':status == 2 && !formDataStatus.name}">
                <el-input :disabled="inputDisabled || formDataStatus.name" class="input_width"  v-model="formData.name"  placeholder="请输入项目名称"></el-input>
              </el-form-item>
              <el-form-item label="流转方式" prop="circulWay" :class="{ itemError: status == 2 && !formDataStatus.circulWay }">
                <el-select v-model="formData.circulWay" @change="resetCirculWay" :disabled="inputDisabled || formDataStatus.circulWay" class="input_width">
                  <el-option label="转让" value="ZR" key="ZR"></el-option>
                  <el-option label="出租" value="CZ" key="CZ"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="流转期限" prop="transferPeriod" :class="{ itemError: status == 2 && (!formDataStatus.transferPeriod || !formDataStatus.circulWay) }" v-if="formData.circulWay==='CZ'">
                <el-input :disabled="inputDisabled || (formDataStatus.transferPeriod && formDataStatus.circulWay)" maxlength="100" class="input_width" v-model="formData.transferPeriod" placeholder="请输入流转期限"></el-input>
              </el-form-item>
              <el-form-item label="承租押金" prop="czprice" :class="{ itemError: status == 2 && (!formDataStatus.czprice || !formDataStatus.circulWay) }" v-if="formData.circulWay==='CZ'">
                <el-input v-model="formData.czprice" type="text" :disabled="inputDisabled || (formDataStatus.czprice && formDataStatus.circulWay)" class="input_width" placeholder="请输入承租押金">
                  <el-button slot="append">元</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="免租期限" prop="rentFreePeriod" :class="{ itemError: status == 2 && (!formDataStatus.rentFreePeriod || !formDataStatus.circulWay) }" v-if="formData.circulWay==='CZ'">
                <el-input v-model="formData.rentFreePeriod" type="text" :disabled="inputDisabled || (formDataStatus.rentFreePeriod && formDataStatus.circulWay)" class="input_width" placeholder="请输入免租期限"></el-input>
              </el-form-item>
              <el-form-item label="租金递增方式" prop="zujindizengtype" :class="{ itemError: status == 2 && (!formDataStatus.zujindizengtype || !formDataStatus.circulWay) }" v-if="formData.circulWay==='CZ'">
                <el-input v-model="formData.zujindizengtype" type="text" :disabled="inputDisabled || (formDataStatus.zujindizengtype && formDataStatus.circulWay)" class="input_width" placeholder="请输入租金递增方式"></el-input>
              </el-form-item>
              <el-form-item label="标的名称" prop="objectName" :class="{ itemError: status == 2 && !formDataStatus.objectName }">
                <el-input :disabled="inputDisabled || formDataStatus.objectName" class="input_width" v-model="formData.objectName" placeholder="请输入标的名称"></el-input>
              </el-form-item>
              <el-form-item v-if="status == 0 ||(status == 2 && !formDataStatus.location)" label="标的位置" prop="address" :class="{'itemError':status == 2 && !formDataStatus.location}">
                <area-tree v-if="status == 0 ||(status == 2 && !formDataStatus.location)" class="input_width"  v-model="formData.address" ></area-tree>
              </el-form-item>
              <el-form-item label="" prop="fullAddress" v-if="status == 0 ||(status == 2 && !formDataStatus.location)">
                <el-input v-model="formData.fullAddress" class="input_width"  placeholder="请输入详细地址（如村、庄等）"></el-input>
              </el-form-item>
              <el-form-item v-if="status==2" label="标的位置" prop="address">
                <el-input  disabled class="input_width"  v-model="formData.location" placeholder="请输入所在地区"></el-input>
              </el-form-item>
              <el-form-item label="权属类型" prop="ownershipType" :class="{ itemError: status == 2 && !formDataStatus.ownershipType }">
                <el-select
                    class="input_width"
                    v-model="formData.ownershipType"
                    :disabled="inputDisabled || formDataStatus.ownershipType"
                    placeholder="请选择权属类型"
                >
                  <el-option label="国有" value="01"></el-option>
                  <el-option label="集体" value="02"></el-option>
                  <el-option label="企业" value="03"></el-option>
                  <el-option label="个人" value="04"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="标的类别" prop="propertychildtype" :class="{ itemError: status == 2 && !formDataStatus.propertychildtype }">
                <el-select class="input_width" :disabled="inputDisabled || formDataStatus.propertychildtype" v-model="formData.propertychildtype" placeholder="请选择标的类别"  @change="hanldePropertychildtypeChange">
                  <el-option label="林木" value="0501" key="0501"></el-option>
                  <el-option label="活立木" value="0502" key="0502"></el-option>
                  <el-option label="原木" value="0503" key="0503"></el-option>
                  <el-option label="地上林产品" value="0504" key="0504"></el-option>
                  <el-option label="林地承包经营权" value="0505" key="0505"></el-option>
                  <el-option label="其他林产品" value="0506" key="0506"></el-option>
                </el-select>
              </el-form-item>
              <!--林木-->
              <div v-if="formData.propertychildtype==='0501'">
                <el-form-item label="品类" prop="biaoditype" :class="{ itemError: status == 2 && (!formDataStatus.biaoditype || !formDataStatus.propertychildtype) }">
                  <el-input type="text" class="input_width" :disabled="inputDisabled || (formDataStatus.biaoditype && formDataStatus.propertychildtype)" v-model="formData.biaoditype" placeholder="请输入林木品类"></el-input>
                </el-form-item>
                <div class="flex-row">
                  <el-form-item label="数量" prop="holdArea" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-input type="text" class="half" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" v-model="formData.holdArea" placeholder="请输入标的数量"></el-input>
                  </el-form-item>
                  <el-form-item prop="holdAreaUnit" label-width="0" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-select class="half" v-model="formData.holdAreaUnit" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" @change="getUnitNumOpiton" placeholder="请选择">
                      <el-option
                          v-for="item in forestList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item label="标的物存放地" prop="cunfangaddress" :class="{ itemError: status == 2 && (!formDataStatus.cunfangaddress || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.cunfangaddress" class="input_width" :disabled="inputDisabled || (formDataStatus.cunfangaddress && formDataStatus.propertychildtype)" placeholder="请输入标的物存放地"></el-input>
                </el-form-item>
                <el-form-item label="标的物现状" prop="remark" :class="{ itemError: status == 2 && (!formDataStatus.remark || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.remark" class="input_width" :disabled="inputDisabled || (formDataStatus.remark && formDataStatus.propertychildtype)" placeholder="请输入标的物现状"></el-input>
                </el-form-item>
              </div>
              <!--活立木-->
              <div v-if="formData.propertychildtype==='0502'">
                <div class="flex-row">
                  <el-form-item label="林地面积" prop="holdArea" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-input type="text" class="half" v-model="formData.holdArea" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请输入林地面积"></el-input>
                  </el-form-item>
                  <el-form-item prop="holdAreaUnit" label-width="0" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-select class="half" v-model="formData.holdAreaUnit" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" @change="getUnitNumOpiton" placeholder="请选择">
                      <el-option
                          v-for="item in treeList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item label="林地起源" prop="ldqy" :class="{ itemError: status == 2 && (!formDataStatus.ldqy || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.ldqy" class="input_width" :disabled="inputDisabled || (formDataStatus.ldqy && formDataStatus.propertychildtype)" placeholder="请输入林地起源"></el-input>
                </el-form-item>
                <el-form-item label="树龄" prop="sl" :class="{ itemError: status == 2 && (!formDataStatus.sl || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.sl" class="input_width" :disabled="inputDisabled || (formDataStatus.sl && formDataStatus.propertychildtype)" placeholder="请输入平均树龄">
                    <el-button slot="append">年</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="平均胸径" prop="pjxj" :class="{ itemError: status == 2 && (!formDataStatus.pjxj || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.pjxj" class="input_width" :disabled="inputDisabled || (formDataStatus.pjxj && formDataStatus.propertychildtype)" placeholder="请输入树的平均胸径">
                    <el-button slot="append">厘米</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="平均树高" prop="pjxg" :class="{ itemError: status == 2 && (!formDataStatus.pjxg || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.pjxg" class="input_width" :disabled="inputDisabled || (formDataStatus.pjxg && formDataStatus.propertychildtype)" placeholder="请输入平均树高">
                    <el-button slot="append">米</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="树种" prop="treeType" :class="{ itemError: status == 2 && (!formDataStatus.treeType || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.treeType" class="input_width" :disabled="inputDisabled || (formDataStatus.treeType && formDataStatus.propertychildtype)" placeholder="请输入树种"></el-input>
                </el-form-item>
                <el-form-item label="预计产量" prop="yjcl" :class="{ itemError: status == 2 && (!formDataStatus.yjcl || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.yjcl" class="input_width" :disabled="inputDisabled || (formDataStatus.yjcl && formDataStatus.propertychildtype)" placeholder="请输入预计产量"></el-input>
                </el-form-item>
                <el-form-item label="产量单位" prop="forestUnit" :class="{ itemError: status == 2 && (!formDataStatus.forestUnit || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.forestUnit" class="input_width" :disabled="inputDisabled || (formDataStatus.forestUnit && formDataStatus.propertychildtype)" placeholder="请输入预计产量的单位"></el-input>
                </el-form-item>
              </div>
              <!--原木-->
              <div v-if="formData.propertychildtype==='0503'">
                <el-form-item label="树种" prop="treeType" :class="{ itemError: status == 2 && (!formDataStatus.treeType || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.treeType" class="input_width" :disabled="inputDisabled || (formDataStatus.treeType && formDataStatus.propertychildtype)" placeholder="请输入树种"></el-input>
                </el-form-item>
                <div class="flex-row">
                  <el-form-item label="数量" prop="holdArea" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-input type="text" class="half" v-model="formData.holdArea" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请输入标的数量"></el-input>
                  </el-form-item>
                  <el-form-item prop="holdAreaUnit" label-width="0" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-select class="half" ref="logRef" v-model="formData.holdAreaUnit" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" @change="getUnitNumOpiton" placeholder="请选择">
                      <el-option
                          v-for="item in forestList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <!--地上林产品-->
              <div v-if="formData.propertychildtype==='0504'">
                <el-form-item label="林产品名称" prop="lcplb" :class="{ itemError: status == 2 && (!formDataStatus.lcplb || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.lcplb" class="input_width" :disabled="inputDisabled || (formDataStatus.lcplb && formDataStatus.propertychildtype)" placeholder="请输入林产品名称"></el-input>
                </el-form-item>
                <div class="flex-row">
                  <el-form-item label="林地面积" prop="holdArea" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-input type="text" class="half" v-model="formData.holdArea" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请输入占地面积"></el-input>
                  </el-form-item>
                  <el-form-item prop="holdAreaUnit" label-width="0" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-select class="half" v-model="formData.holdAreaUnit" @change="getUnitNumOpiton" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请选择">
                      <el-option
                          v-for="item in livingTreesList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item label="树种" prop="treeType" :class="{ itemError: status == 2 && (!formDataStatus.treeType || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.treeType" class="input_width" :disabled="inputDisabled || (formDataStatus.treeType && formDataStatus.propertychildtype)" placeholder="请输入树种"></el-input>
                </el-form-item>
                <el-form-item label="预计产量" prop="yjcl" :class="{ itemError: status == 2 && (!formDataStatus.yjcl || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.yjcl" class="input_width" :disabled="inputDisabled || (formDataStatus.yjcl && formDataStatus.propertychildtype)" placeholder="请输入预计产量"></el-input>
                </el-form-item>
                <el-form-item label="产量单位" prop="forestUnit" :class="{ itemError: status == 2 && (!formDataStatus.forestUnit || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.forestUnit" class="input_width" :disabled="inputDisabled || (formDataStatus.forestUnit && formDataStatus.propertychildtype)" placeholder="请输入预计产量的单位"></el-input>
                </el-form-item>
              </div>
              <!--林地承包经营权-->
              <div v-if="formData.propertychildtype==='0505'">
                <div class="flex-row">
                  <el-form-item label="林地面积" prop="holdArea" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-input type="text" class="half" v-model="formData.holdArea" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请输入占地面积"></el-input>
                  </el-form-item>
                  <el-form-item prop="holdAreaUnit" label-width="0" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-select class="half" v-model="formData.holdAreaUnit" @change="getUnitNumOpiton" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请选择">
                      <el-option
                          v-for="item in livingTreesList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item label="林地用途" prop="ldyt" :class="{ itemError: status == 2 && (!formDataStatus.ldyt || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.ldyt" class="input_width" :disabled="inputDisabled || (formDataStatus.ldyt && formDataStatus.propertychildtype)" placeholder="请输入林地用途"></el-input>
                </el-form-item>
                <el-form-item label="树龄" prop="sl" :class="{ itemError: status == 2 && (!formDataStatus.sl || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.sl" class="input_width" :disabled="inputDisabled || (formDataStatus.sl && formDataStatus.propertychildtype)" placeholder="请输入平均树龄">
                    <el-button slot="append">年</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="平均胸径" prop="pjxj" :class="{ itemError: status == 2 && (!formDataStatus.pjxj || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.pjxj" class="input_width" :disabled="inputDisabled || (formDataStatus.pjxj && formDataStatus.propertychildtype)" placeholder="请输入树的平均胸径">
                    <el-button slot="append">厘米</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="平均树高" prop="pjxg" :class="{ itemError: status == 2 && (!formDataStatus.pjxg || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.pjxg" class="input_width" :disabled="inputDisabled || (formDataStatus.pjxg && formDataStatus.propertychildtype)" placeholder="请输入平均树高">
                    <el-button slot="append">米</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="林权期限" prop="lqqx" :class="{ itemError: status == 2 && (!formDataStatus.lqqx || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.lqqx" class="input_width" :disabled="inputDisabled || (formDataStatus.lqqx && formDataStatus.propertychildtype)" placeholder="请输入林权期限"></el-input>
                </el-form-item>
                <el-form-item label="树种" prop="treeType" :class="{ itemError: status == 2 && (!formDataStatus.treeType || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.treeType" class="input_width" :disabled="inputDisabled || (formDataStatus.treeType && formDataStatus.propertychildtype)" placeholder="请输入树种"></el-input>
                </el-form-item>
              </div>
              <!--其他林产品-->
              <div v-if="formData.propertychildtype==='0506'">
                <el-form-item label="林产品类别" prop="lcplb" :class="{ itemError: status == 2 && (!formDataStatus.lcplb || !formDataStatus.propertychildtype) }">
                  <el-input type="text" v-model="formData.lcplb" class="input_width" :disabled="inputDisabled || (formDataStatus.lcplb && formDataStatus.propertychildtype)" placeholder="请输入林产品名称"></el-input>
                </el-form-item>
                <div class="flex-row">
                  <el-form-item label="数量" prop="holdArea" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-input type="text" class="half" v-model="formData.holdArea" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请输入标的数量"></el-input>
                  </el-form-item>
                  <el-form-item prop="holdAreaUnit" label-width="0" :class="{ itemError: status == 2 && (!formDataStatus.holdArea || !formDataStatus.propertychildtype) }">
                    <el-select class="half" v-model="formData.holdAreaUnit" @change="getUnitNumOpiton" :disabled="inputDisabled || (formDataStatus.holdArea && formDataStatus.propertychildtype)" placeholder="请选择">
                      <el-option
                          v-for="item in otherList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
<!--              <el-form-item label="林地属性" prop="forestAttr" :class="{'itemError':status == 2 && !formDataStatus.forestAttr}">-->
<!--                <el-select  :disabled="inputDisabled || formDataStatus.forestAttr" class="input_width"  v-model="formData.forestAttr"  placeholder="请输入请选择林地属性" >-->
<!--                  <el-option v-for="item in projectRegionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="占地面积" :class="{'itemError':status == 2 && !formDataStatus.holdArea}" prop="holdArea">-->
<!--                <el-input  :disabled="inputDisabled || formDataStatus.holdArea" class="half"  v-model="formData.holdArea"  @keyup.native="changeCode('holdArea')"  placeholder="请输入占地面积" @blur="holdAreaChange">-->
<!--                </el-input>-->
<!--                <el-select v-model="formData.holdAreaUnit"  placeholder="请选择面积单位" class="half" @change="holdAreaChange" :disabled="inputDisabled || formDataStatus.holdArea">-->
<!--                  <el-option v-for="(item, index) in forestAttrList" :key="index" :label="item" :value="item"></el-option>-->
<!--                </el-select>-->
<!--                <span v-if="formData.holdAreaUnit != '亩' && holdAreaNum && holdAreaNum > 0 ">{{`≈${holdAreaNum}亩`}}</span>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="林木蓄积" :class="{'itemError':status == 2 && !formDataStatus.forestStock}">-->
<!--                <el-input v-model="formData.forestStock"  placeholder="请输入林木蓄积" :disabled="inputDisabled || formDataStatus.forestStock" class="input_width" >-->
<!--                   <template slot="append">立方米</template>-->
<!--                </el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="树种" :class="{'itemError':status == 2 && !formDataStatus.treeType}">-->
<!--                <el-input  :disabled="inputDisabled || formDataStatus.treeType" class="input_width"  v-model="formData.treeType"  placeholder="请输入树种"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="转出方式" prop="transferMethod" :class="{itemError: status == 2 && !formDataStatus.transferMethod }">-->
<!--                <el-input :disabled="inputDisabled || formDataStatus.transferMethod" class="input_width" v-model="formData.transferMethod" placeholder="请输入转出方式"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="是否存在他项权利人" prop="isOtherRightsHolder" :class="{'itemError':status == 2 && !formDataStatus.isOtherRightsHolder}">
                <el-radio-group  v-model="formData.isOtherRightsHolder" :disabled="inputDisabled || formDataStatus.isOtherRightsHolder"  >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="他项权利人" v-if="formData.isOtherRightsHolder == 1" prop="otherRightsHolder" :class="{'itemError':status == 2 && (!formDataStatus.otherRightsHolder || !formDataStatus.isOtherRightsHolder)}">
                <el-input v-model="formData.otherRightsHolder" placeholder="请输入他项权利人" :disabled="inputDisabled || (formDataStatus.isOtherRightsHolder && formDataStatus.otherRightsHolder)" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="他项权利内容" v-if="formData.isOtherRightsHolder == 1" prop="otherRightsContent" :class="{'itemError':status == 2 && (!formDataStatus.otherRightsContent || !formDataStatus.isOtherRightsHolder)}">
                <el-input v-model="formData.otherRightsContent" placeholder="请输入他项权利内容" :disabled="inputDisabled ||(formDataStatus.isOtherRightsHolder && formDataStatus.otherRightsContent)" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="标的图" :class="{'itemError':status == 2 && !formDataStatus.imgList}">
                <Upload v-model="imgUrl" buttonText="上传"  @fileNameEvt="fileNameEvt" :size="true" v-if="status == 0 || (status == 2 && !formDataStatus.imgList)"></Upload>
                  <div v-for="(item, index) in formData.imgList" :key="index" >
                    <div class="lookAddr">
                      <span class="name" :class="{'redFont':status == 2 && !item.flag}">{{ item.imgName }}</span>
                      <el-link class="mr20 blueC" :underline="false" v-if="item.imgUrl" :href="item.imgUrl"  target="_blank" >详情</el-link>
                      <i @click.prevent.stop="dels(index)" class="el-icon-delete" v-if="status == 0 ||status == 2 && !item.flag"></i>
                    </div>
                  </div>
              </el-form-item>
            </div>
          </div>
          <div id="1">
            <div class="h_bg p50">
              <h3>交易信息</h3>
              <span v-if="!inputDisabled">带“<span class="redF xing">*</span>”号为必填项</span>
            </div>
            <div class="m50">
                <el-form-item label="交易方式" prop="tranferType" :class="{'itemError':status == 2 && !formDataStatus.tranferType}">
                  <el-radio-group :disabled="inputDisabled || formDataStatus.tranferType" v-model="formData.tranferType" @change="tranferTypeChange">
                    <el-radio :label="1">网络竞价</el-radio>
                    <el-radio :label="2">协议转让</el-radio>
                    <el-radio :label="3">预售</el-radio>
                  </el-radio-group>
                </el-form-item>
<!--                <el-form-item :label="formData.tranferType == 1 ? '起拍价格' : '标的价格'"  prop="amount" :class="{'itemError':status == 2 && !formDataStatus.amount}">-->
<!--                  <el-input  :disabled="inputDisabled || (formDataStatus.tranferType &&  formDataStatus.amount)" class="half"  v-model="formData.amount" @keyup.native="changeCode('amount')" :placeholder="formData.tranferType == 1 ? '请输入起拍价格' : '请输入标的价格'" :maxlength="15">-->
<!--                  </el-input>-->
<!--                  <el-select v-model="formData.amountUnit"  :disabled="inputDisabled || (formDataStatus.tranferType &&  formDataStatus.amountUnit)"  class="half" >-->
<!--                    <el-option label="元" :value="'1'" placeholder="请选择"></el-option>-->
<!--                    <el-option label="万元" :value="'2'"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="预付款" prop="isAdvancePayment" :class="{'itemError':status == 2 && !formDataStatus.isAdvancePayment}">-->
<!--                  <el-select  :disabled="inputDisabled || formDataStatus.isAdvancePayment"  v-model="formData.isAdvancePayment"  placeholder="是/否" class='mr10' style="width: 100px;">-->
<!--                    <el-option label="是" :value="1"></el-option>-->
<!--                    <el-option label="否" :value="0"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="" prop="advancePaymentAmount" v-if='formData.isAdvancePayment == 1'>-->
<!--                  <el-input  :disabled="inputDisabled || (formDataStatus.isAdvancePayment && formDataStatus.advancePaymentAmount)" class="input_width"  v-model="formData.advancePaymentAmount" @keyup.native="changeCode('advancePaymentAmount')"  placeholder="请输入预付款" :maxlength="15">-->
<!--                    <template slot="append">元</template>-->
<!--                  </el-input>-->
<!--                </el-form-item>-->
              <el-form-item label="出价方式" prop="bidType" :class="{itemError: status == 2 && !formDataStatus.bidType}">
                <el-radio-group
                    :disabled="inputDisabled || formDataStatus.bidType"
                    v-model="formData.bidType"
                >
                  <el-radio label="0">总价</el-radio>
                  <el-radio label="1">单价</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="flex-row">
                <el-form-item :label="formData.tranferType == 1 ? '起拍价格' : '标的价格'" prop="listingPrice" :class="{itemError: status == 2 && (!formDataStatus.listingPrice  || !formDataStatus.bidType)}">
                  <el-input :placeholder="
                formData.tranferType == 1 ? '请输入起拍价格' : '请输入标的价格'
              " v-model="formData.listingPrice" :disabled="inputDisabled || formDataStatus.listingPrice && formDataStatus.bidType" maxlength="9" style="width: 200px;margin-right:10px;">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
                <el-select size="mini" v-model="formData.unitNum" :disabled="inputDisabled || formDataStatus.listingPrice && formDataStatus.holdArea && formDataStatus.bidType" v-if="formData.bidType==='1'" class="half" placeholder="请选择数量单位">
                  <el-option v-for="(item,index) in unitNumOption" :label="item" :value="item" :key="index"></el-option>
                </el-select>
                <el-select size="mini" v-model="formData.unitTime" :disabled="inputDisabled || formDataStatus.listingPrice && formDataStatus.bidType" v-if="formData.bidType==='1'" class="half" placeholder="请选择时间单位">
                  <el-option value="1" label="年"></el-option>
                  <el-option value="2" label="季度"></el-option>
                  <el-option value="3" label="月"></el-option>
                  <el-option value="0" label="无"></el-option>
                </el-select>
              </div>
              <el-form-item label="付款方式" prop="paymentMethod" :class="{itemError: status == 2 && !formDataStatus.paymentMethod}">
                <el-input
                    class="input_width"
                    :disabled="inputDisabled || formDataStatus.paymentMethod"
                    v-model="formData.paymentMethod"
                    placeholder="请输入付款方式"
                    maxlength="200"
                ></el-input>
              </el-form-item>
              </div>
          </div>
          <div id="2" v-if="formData.mainPartIdentityType">
            <div class="h_bg p50">
              <h3>标的物所属主体信息</h3>
              <span>带"<span class="redF xing">*</span>"号为必填项</span>
            </div>
            <div class="m50">
              <el-form-item label="主体类型" prop="mainPartIdentityType" :class="{itemError: status == 2 && !formDataStatus.mainPartIdentityType}">
                <el-radio-group v-model="formData.mainPartIdentityType"  :disabled="inputDisabled || formDataStatus.mainPartIdentityType"  @change="restMainPartInfo()">
<!--                  <el-radio :label="1">企业</el-radio>-->
<!--                  <el-radio :label="2">组织</el-radio>-->
<!--                  <el-radio :label="3">个人</el-radio>-->
                  <el-radio label="01">企事业单位</el-radio>
                  <el-radio label="02">自然人</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="转让方类型" prop="transferType" :class="{itemError: status == 2 && !formDataStatus.transferType}">
                <el-select v-model="formData.transferType" class="input_width" :disabled="inputDisabled || formDataStatus.transferType" placeholder="请选择转让方类型">
                  <el-option key="01" value="01" label="国有企业"></el-option>
                  <el-option key="02" value="02" label="行政事业"></el-option>
                  <el-option key="99" value="99" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="formData.mainPartIdentityType == '01' ? '企业名称' : '姓名'" prop="mainPartIdentityName" :class="{itemError: status == 2 && !formDataStatus.mainPartIdentityName}" >
                <el-input v-model="formData.mainPartIdentityName"  :disabled="inputDisabled || formDataStatus.mainPartIdentityName"  placeholder="请输入" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="统一信用代码" prop="mainPartCreditCode" :class="{itemError: status == 2 && !formDataStatus.mainPartCreditCode}" v-if="formData.mainPartIdentityType=='01'">
                <el-input v-model="formData.mainPartCreditCode" :disabled="inputDisabled || formDataStatus.mainPartCreditCode"   placeholder="请输入统一信用代码" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="注册地址" prop="mainPartRegistAddrss" :class="{itemError: status == 2 && !formDataStatus.mainPartRegistAddrss}" v-if="formData.mainPartIdentityType=='01'">
                <el-input v-model="formData.mainPartRegistAddrss" :disabled="inputDisabled || formDataStatus.mainPartRegistAddrss"   placeholder="请输入注册地址" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="法定代表人" prop="mainPartLegalName" :class="{itemError: status == 2 && !formDataStatus.mainPartLegalName}" v-if="formData.mainPartIdentityType=='01'">
                <el-input v-model="formData.mainPartLegalName"  :disabled="inputDisabled || formDataStatus.mainPartLegalName"  placeholder="请输入法定代表人" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="mainPartIdNumber" :class="{itemError: status == 2 && !formDataStatus.mainPartIdNumber}" v-if="formData.mainPartIdentityType=='02'">
                <el-input v-model="formData.mainPartIdNumber"  :disabled="inputDisabled || formDataStatus.mainPartIdNumber"  placeholder="请输入身份证号" class="input_width" :maxlength="18"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="mainPartContactPerson" :class="{itemError: status == 2 && !formDataStatus.mainPartContactPerson}" v-if="formData.mainPartIdentityType=='01'">
                <el-input v-model="formData.mainPartContactPerson" :disabled="inputDisabled || formDataStatus.mainPartContactPerson"   placeholder="请输入联系人" class="input_width" :maxlength="10"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="mainPartContactNumber" :class="{itemError: status == 2 && !formDataStatus.mainPartContactNumber}">
                <el-input maxlength="11" v-model="formData.mainPartContactNumber" :disabled="inputDisabled || formDataStatus.mainPartContactNumber"   placeholder="请输入联系电话" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="联系地址" prop="mainPartContactAddress" :class="{itemError: status == 2 && !formDataStatus.mainPartContactAddress}" v-if="formData.mainPartIdentityType=='01'">
                <el-input v-model="formData.mainPartContactAddress" :disabled="inputDisabled || formDataStatus.mainPartContactAddress"   placeholder="请输入联系地址" class="input_width"></el-input>
              </el-form-item>
              <el-form-item label="企业性质" prop="companyProperties" :class="{itemError: status == 2 && !formDataStatus.companyProperties}" v-if="formData.mainPartIdentityType=='01'">
                <el-select v-model="formData.companyProperties" :disabled="inputDisabled || formDataStatus.companyProperties" class="input_width" placeholder="请选择企业性质（经济类型）">
                  <el-option
                      v-for="item in companyPropertiesList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="企业类型" prop="companyType" :class="{itemError: status == 2 && !formDataStatus.companyType}" v-if="formData.mainPartIdentityType=='01'">
                <el-select v-model="formData.companyType" :disabled="inputDisabled || formDataStatus.companyType" class="input_width" placeholder="请选择企业类型">
                  <el-option
                      v-for="item in companyTypeList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经济规模" prop="economicScale" :class="{itemError: status == 2 && !formDataStatus.economicScale}" v-if="formData.mainPartIdentityType=='01'">
                <el-select v-model="formData.economicScale" :disabled="inputDisabled || formDataStatus.economicScale" class="input_width" placeholder="请选择经济规模">
                  <el-option
                      v-for="item in economicScaleList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属行业" prop="companyIndustryCode" :class="{itemError: status == 2 && !formDataStatus.companyIndustryCode}" v-if="formData.mainPartIdentityType=='01'">
                <el-cascader
                    :disabled="inputDisabled || formDataStatus.companyIndustryCode"
                    style="width: 300px;"
                    clearable
                    filterable
                    v-model="formData.companyIndustryCode"
                    placeholder="请选择所属行业"
                    :options="companyIndustryCodeList"
                    :props="{ label: 'industryName',value: 'industryCode',children: 'subsetList' }"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="资金来源" prop="sourceFund" :class="{itemError: status == 2 && !formDataStatus.sourceFund}" v-if="formData.mainPartIdentityType=='02'">
                <el-select v-model="formData.sourceFund" :disabled="inputDisabled || formDataStatus.sourceFund" class="input_width" placeholder="请选择资金来源">
                  <el-option
                      v-for="item in sourceFundList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div :id="formData.mainPartIdentityType ? 3 : 2">
          <div class="h_bg p50">
            <h3>所需资料</h3>
            <span>（支持上传pdf或图片格式）</span>
          </div>
          <div class="m50">
            <el-form class="form formRelative">
              <el-row class="mt20">
                <el-col v-for="(item) of roleFileList" :key="item.id">
                  <div v-if="item.maxNumber == 1">
                    <el-form-item  :class="{'itemError':status == 2 && !item.status,'actives': status == 0 && item.isRequire}" :label="item.fileName"  label-width="390px"  style="margin-bottom: 0;" >
                      <DataUpload style="display:inline-block; margin-left:50px;" :fileFuther="item" :downFlag="downFlag" :orNo="orNo" />
                    </el-form-item>
                  </div>
                  <div v-else>
                    <el-form-item :label="`${item.fileName}(可上传多份)`"  :class="{'itemError':status == 2 && !item.status,'actives': status == 0 && item.isRequire}"  label-width="390px"  style="margin-bottom: 0;">
                      <ListUpload  style="display: inline-block; margin-left:50px;" :fileFuther="item"  :downFlag="downFlag" :flag='2' :orNo="orNo" />
                    </el-form-item>
                  </div>
                </el-col>
                 <div>
                  <Upload v-model="otherImgUrl" v-if="status == 0 || status == 2" buttonText="上传其他资料"  @fileNameEvt="fileNameOtherEvt" :size="true"></Upload>
                  <div v-for="(item,ind) of formData.otherFileList" :key="ind">
                    <el-form-item  :label="item.fileName"  :class="{'itemError':status == 2 && !item.flag}" label-width="390px" style="margin-bottom: 0;">
                      <OtherOneUpload style="display: inline-block; margin-left:50px;" :fileFuther="item" :index="ind" @delOtherImg="delOtherImg()" :delBtn="!item.flag" />
                    </el-form-item>
                  </div>
                </div>
              </el-row>
            </el-form>
            <!-- <AgreeDialog :agreeShow="status == 0 ? true : false" @checkAgree="checkAgreeEvt" @agreementName="getAgreeName"></AgreeDialog> -->
          </div>
        </div>
        <div class="btn_wrap" >
          <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
          <div v-if="status == 2 || status == 0" style="display: inline-block; margin-left:10px;">
            <el-button class="btns red" @click="save()">仅保存</el-button>
            <el-button class="btns red" @click="sumbitEvt()">保存同时提交审核</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
    <div class="el-container" v-else>
      <div class="main-block">
        <div class="top-title">我的挂牌</div>
        <div  style="margin: 0 123px;">
          <div class="status-wrap" :class="status == 5 || status == 7 || status == 9 ? 'checkErrorBg' : 'checkSuccessBg'" >
            <div class="left">
              <div class="img-warp" :class="status == 5 || status == 7 || status == 9 ? 'checkError' : 'checkSuccess'" >
                <img :src="statusImg" alt="" />
              </div>
              <div class="status"> 申请状态<br />
                <p v-if="status == 5 || status == 7 || status == 9" style="color:#EF5147 ;">{{statusCheck(status)}}</p>
                <p v-else style="color:#91A442;">{{statusCheck(status)}}</p>
              </div>
            </div>
          </div>
          <div class="btn_wrap" style="margin: 40px 0;">
            <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataUpload from '@/components/DataUpload/OneUpload.vue'
import ListUpload from '@/components/DataUpload/ListUpload.vue'
import OtherOneUpload from '@/components/DataUpload/OtherOneUpload.vue'
import VueQr from 'vue-qr'
import HeaderImg from '@/components/HeaderImg'
import ErrorImg from '@/assets/img/check_error.png'
import LoadingImg from '@/assets/img/check_ing.png'
import SuccessImg from '@/assets/img/check_success.png'
import publicFunction from '@/utils/publicFunction'
import {
  addrOptions,
  companyPropertiesList,
  companyTypeList,
  economicScaleList,
  forestOptions, sourceFundList
} from '@/common/options.js'
import Upload from "@/components/Upload/UpLoad.vue";
import AreaTree from "../../../property-exchange-center/property-listing-application/components/AreaTree";
import AgreeDialog from '@/components/agreeDialog'
export default {
  components: {
    DataUpload,
    ListUpload,
    VueQr,
    HeaderImg,
    Upload,
    AreaTree,
    OtherOneUpload,
    AgreeDialog,
  },
  data() {
    const validateDecimal2 = (rule,value,callback) =>{
      let reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
      if(!value){
        callback(new Error('请输入'))
      }else if(!reg.test(value)){
        callback(new Error('请输入正数，最多可保留2位小数'))
      }else{
        callback();
      }
    };
    const validateNum2 = (rule,value,callback) =>{
      let reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
      if(value&&!reg.test(value)){
        callback(new Error('请输入正数，最多可保留2位小数'))
      }else{
        callback();
      }
    };
    const validateIdNum = (rule,value,callback) =>{
      const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if(!value){
        callback(new Error('请输入'))
      }else if(!reg.test(value)){
        callback(new Error('请输入正确的身份证号码'))
      }else{
        callback();
      }
    }
    const checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系电话"));
      }
      if (!/^\d{11}$/.test(value)) {
        callback(new Error("请输入正确的11位联系电话"));
      }
      callback();
    };
    return {
      companyPropertiesList,
      companyTypeList,
      economicScaleList,
      sourceFundList,
      companyIndustryCodeList: [],
      forestList: [
        { label: '吨', id: '13'},
        { label: '公斤', id: '14'},
        { label: '个', id: '16'}
      ],
      treeList: [
        { label: '亩', id: '09'},
      ],
      livingTreesList: [
        { label: '亩', id: '09'},
        { label: '平方米', id: '18'}
      ],
      otherList: [
        { label: '亩', id: '09'},
        { label: '平方米', id: '18'},
        { label: '吨', id: '13'},
        { label: '公斤', id: '14'},
        { label: '个', id: '16'}
      ],
      unitNumOption: ['无'], //起拍价格数量单位选项
      unitTimeOption: {
        '0': '无',
        '1': '年 ',
        '2': '季度 ',
        '3': '月 '
      },
      projectSortOptions: addrOptions,
      projectRegionOptions: forestOptions,
      rules: {
        circulWay: [{ required: true, message: '请选择', trigger: 'change' }],
        czprice: [{ required: true, trigger: 'blur',validator: validateDecimal2 }],
        rentFreePeriod: [{ required: true, message: '请输入', trigger: 'blur' }],
        zujindizengtype: [{ required: true, message: '请输入', trigger: 'blur' }],
        objectName: [{ required: true, message: '请输入', trigger: 'blur' }],
        ownershipType: [{ required: true, message: '请选择', trigger: 'change' }],
        propertychildtype: [{ required: true, message: '请选择', trigger: 'change' }],
        transferType: [{ required: true, message: '请选择', trigger: 'change' }],
        companyProperties: [{ required: true, message: '请选择', trigger: 'change' }],
        companyType: [{ required: true, message: '请选择', trigger: 'change' }],
        economicScale: [{ required: true, message: '请选择', trigger: 'change' }],
        companyIndustryCode: [{ required: true, message: '请选择', trigger: 'change' }],
        sourceFund: [{ required: true, message: '请选择', trigger: 'change' }],
        biaoditype: [{ required: true, message: '请输入', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        fullAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        // forestAttr: [
        //   { required: true, message: '请选择', trigger: 'change' }
        // ],
        holdArea: [
          { required: true, validator: validateDecimal2, trigger: 'blur' }
        ],
        holdAreaUnit: [{ required: true, message: "请选择", trigger: "change" }],
        treeType: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        cunfangaddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }],
        yjcl: [{ required: true, validator: validateDecimal2, trigger: 'blur' }],
        forestUnit: [{ required: true, message: '请输入', trigger: 'blur' }],
        lcplb: [{ required: true, message: '请输入', trigger: 'blur' }],
        lqqx: [{ required: true, message: '请输入', trigger: 'blur' }],
        sl: [{ required: false, trigger: "blur",validator: validateNum2 }],
        pjxj: [{ required: false, trigger: "blur",validator: validateNum2 }],
        pjxg: [{ required: false, trigger: "blur",validator: validateNum2 }],
        transferPeriod: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        isOtherRightsHolder: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        otherRightsHolder: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        otherRightsContent: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        submitGoodsTime: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        isAdvancePayment: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        advancePaymentAmount: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        mainPartIdentityType: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartIdentityName: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartCreditCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartRegistAddrss: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartLegalName: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartIdNumber: [{ required: true, validator: validateIdNum, trigger: 'blur' }],
        mainPartContactPerson: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartContactNumber: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        mainPartContactAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        // transferMethod: [
        //   { required: true, message: '请输入', trigger: 'blur' },
        // ],
        bidType: [
          { required: true, message: '请输入', trigger: 'change' },
        ],
        listingPrice:[
          { required: true, trigger: 'blur', validator: validateDecimal2 },
        ],
        paymentMethod: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
      formData: {
        circulWay: '', //流转方式
        czprice: '', //承租押金
        rentFreePeriod: '', //免租期限
        zujindizengtype: '', //租金递增方式
        zlqx: '', // 租赁期限   默认取“流转期限”
        zftype: '', //租金支付方式    默认取“付款方式”
        objectName: '', //标的名称
        ownershipType: '', //权属类型
        propertytype: '05', //标的类别  04-土地  05-林木
        propertychildtype: '', //标的子类别
        transferType: '', //转让方类型
        companyProperties: '', //企业性质
        companyType: '', //企业类型
        economicScale: '', //经济规模
        companyIndustryCode: [], //所属行业
        sourceFund: '', //资金来源
        biaodiname: '', // 标的物名称 前端不显示   直接取标的名称
        biaoditype: '', //林木品类
        propertyprice: '', // 取“起拍价格”、或“标的价格”；不用输入
        cunfangaddress: '', //标的物存放地
        remark: '', //标的物现状
        ldqy: '', //林地起源
        sl: '', //树龄
        pjxj: '', //平均胸径
        pjxg: '', //平均树高
        yjcl: '', //预计产量
        forestUnit: '', //产量单位
        lcplb: '', //林产品名称
        ldyt: '', //林地用途
        lqqx: '', //林权期限
        bidType: '',
        listingPrice: '', //起拍价格
        paymentMethod: '', //付款方式
        unitTime: '',
        unitNum: '',
        // transferMethod: "", //转出方式
        areaConfigId: '',
        id: this.$route.query.id,
        businessType:'2', //业务类型
        name: "", //项目名称
        location: '', // 所在地
        // forestAttr: '', // 林地属性
        holdArea: '', //持有面基
        treeType: '', //树种
        transferPeriod: '', //流转期限
        tranferType: 1, //交易方式
        amount:'', // 价格
        submitGoodsTime:'', // 交货时间
        isAdvancePayment: '', // 是否预付 1是  0否
        advancePaymentAmount:'', // 预付金额
        fileList: [],
        reason:'',
        address:'',
        fullAddress: '',
        imgList: [], //标的图url
        isOtherRightsHolder: 2, //是否存在他项权利人
        otherRightsHolder: '', //他项权利人
        otherRightsContent: '', //他项权利内容
        // forestStock: '', // 林木蓄积
        otherFileList: [], // 其他文件
        holdAreaUnit: "",
        mainPartIdentityType:'',  //主体身份类型  1企业 2组织  3个人
        mainPartIdentityName:'',
        mainPartCreditCode: '',
        mainPartRegistAddrss:'',
        mainPartLegalName:'',
        mainPartContactPerson: '',
        mainPartContactNumber: '',
        mainPartContactAddress:'',
        mainPartIdNumber: '',
        listingMainPart:{
          transferType: '', //转让方类型
          companyProperties: '', //企业性质
          companyType: '', //企业类型
          economicScale: '', //经济规模
          companyIndustryCode: '', //所属行业
          sourceFund: '', //资金来源
          identityType: '',  //主体身份类型  1企业 2组织  3个人
          name: '',  //企业名称/组织名称/姓名
          creditCode: '',  //统一信用代码
          registAddrss: '',  //注册地址
          legalName: '',  //法定代表人
          contactPerson: '',  //联系人
          contactNumber: '',  //联系电话
          contactAddress: '',  //联系地址
          idNumber: '',  //身份证号  ;
        },
        amountUnit:'1', //
      },
      imgUrl:'', // 标的图的url
      fileName:'', //标的图的name
      otherImgUrl:'', // 其他资料的url
      otherFileName:'', //其他资料的name
      formDataStatus: {
        circulWay: false, //流转方式
        czprice: false, //承租押金
        rentFreePeriod: false, //免租期限
        zujindizengtype: false, //租金递增方式
        objectName: false, //标的名称
        ownershipType: false, //权属类型
        propertychildtype: false, //标的子类别
        transferType: false, //转让方类型
        companyProperties: false, //企业性质
        companyType: false, //企业类型
        economicScale: false, //经济规模
        companyIndustryCode: false, //所属行业
        sourceFund: false, // 资金来源
        biaoditype: false, //林木品类
        cunfangaddress: false, //标的物存放地
        remark: false, //标的物现状
        ldqy: false, //林地起源
        sl: false, //树龄
        pjxj: false, //平均胸径
        pjxg: false, //平均树高
        yjcl: false, //预计产量
        forestUnit: false, //产量单位
        lcplb: false, //林产品名称
        ldyt: false, //林地用途
        lqqx: false, //林权期限
        bidType: false,
        listingPrice: false,
        paymentMethod: false,
        // transferMethod: false, //转出方式
        id: this.$route.query.id,
        name: false, //项目名称
        location: false, // 所在地
        // forestAttr: false, // 林地属性
        holdArea: false, //持有面基
        treeType: false, //树种
        transferPeriod: false, //流转期限
        tranferType: false, //交易方式
        amount:false, // 价格
        submitGoodsTime:false, // 交货时间
        isAdvancePayment: false, // 是否预付 1是  0否
        advancePaymentAmount:false, // 预付金额
        isOtherRightsHolder: false, //是否存在他项权利人
        otherRightsHolder: false, //他项权利人
        otherRightsContent: false, //他项权利内容
        // forestStock: false, // 林木蓄积
        imgList: false, //
        mainPartIdentityType:false,  //主体身份类型  1企业 2组织  3个人
        mainPartIdentityName:false,
        mainPartCreditCode: false,
        mainPartRegistAddrss:false,
        mainPartLegalName:false,
        mainPartContactPerson: false,
        mainPartContactNumber: false,
        mainPartContactAddress:false,
        mainPartIdNumber: false,
        amountUnit: false,
      },
      headerList: [
        { name: "首页", path: "/Home" },
        { name: '我的挂牌', path: '/MyApplyList' },
      ],
      leftBanner: ['标的信息','交易信息', '所需资料'],
      chooseIndex: 0,
      role: '',
      status: '',
      listingMode: '',
      inputDisabled: true,
      statusImg: ErrorImg,
      allFileList: [], //全部文件列表
      roleFileList: [], //当前角色文件列表
      params: {},
      downFlag: true,
      Loading: false,
      // pickerOptions: {
      //   disabledDate: (time) => {
      //     return this.dealDisabledDate(time)
      //   }
      // },
      orNo: false,
      forestAttrList: ["亩","公顷", "平方米", "平方千米"],
      holdAreaNum:'',//亩
      agreementName:'',
      checkAgree: false,
    }
  },
  watch: {
    imgUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.imgList.push({
            imgUrl: newVal,
            imgName: this.fileName,
          })
          this.imgUrl = ''
          this.fileName = ''
        }
      },
    },
    otherImgUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.otherFileList.push({
            fileUrl: newVal,
            fileName: this.otherFileName,
          })
          this.otherImgUrl = ''
          this.otherFileName = ''
        }
      },
    },
  },
  async mounted() {
    window.scrollTo(0, 0)
    this.status = this.$route.query.status + ''
    this.getCompanyIndustryCodeList()
    if (this.status == 0 ) {
      this.inputDisabled = false
    } else if(this.status == 1){
      this.downFlag = false
      this.orNo = true
      this.inputDisabled = true
      this.statusImg = LoadingImg
    } else if(this.status == 2){
      this.inputDisabled = false
      this.statusImg = ErrorImg
    } else {
      if(this.status == 5 || this.status == 7 || this.status == 9){
        this.statusImg = ErrorImg
      } else {
        this.statusImg = SuccessImg
      }
      this.inputDisabled = true
      this.downFlag = false
    }
    this.headerList.push({ name: `${this.statusCheck(this.status)}(林权)`,})
    await this.getTableData() // 获取详情信息
  },
  methods: {
    resetCirculWay(){
      this.formData.transferPeriod = ''
      this.formData.czprice = ''
      this.formData.rentFreePeriod = ''
      this.formData.zujindizengtype = ''
    },
    getCompanyIndustryCodeList(){
      this.$api.user.getSelectIndustryList().then(res=>{
        if(res.code===1000){
          this.companyIndustryCodeList = res.data
        }
      })
    },
    getLabel(id,list){
      return list.find(item=>item.id===id)?.label??''
    },
    //起拍价格数量单位选项
    getUnitNumOpiton(){
      this.formData.unitNum = ''
      this.unitNumOption = ['无']
      if(this.formData.holdAreaUnit){
        if(this.formData.propertychildtype==='0501'||this.formData.propertychildtype==='0503'){
          this.unitNumOption.unshift(this.getLabel(this.formData.holdAreaUnit,this.forestList))
        }
        if(this.formData.propertychildtype==='0502'){
          this.unitNumOption.unshift(this.getLabel(this.formData.holdAreaUnit,this.treeList))
        }
        if(this.formData.propertychildtype==='0504'||this.formData.propertychildtype==='0505'){
          this.unitNumOption.unshift(this.getLabel(this.formData.holdAreaUnit,this.livingTreesList))
        }
        if(this.formData.propertychildtype==='0506'){
          this.unitNumOption.unshift(this.getLabel(this.formData.holdAreaUnit,this.otherList))
        }
      }
    },
    hanldePropertychildtypeChange(){
      //重置初始值
      this.formData.biaoditype = ''
      this.formData.holdArea = ''
      this.formData.holdAreaUnit = ''
      this.formData.cunfangaddress = ''
      this.formData.remark = ''
      this.formData.ldqy = ''
      this.formData.sl = ''
      this.formData.pjxj = ''
      this.formData.pjxg = ''
      this.formData.treeType = ''
      this.formData.yjcl = ''
      this.formData.forestUnit = ''
      this.formData.lcplb = ''
      this.formData.ldyt = ''
      this.formData.lqqx = ''
      this.getUnitNumOpiton()
    },
     getAgreeName(v){
      this.agreementName = v
    },
    checkAgreeEvt(v){
      this.checkAgree = v
    },
    fileNameOtherEvt(v) {
      this.otherFileName = v
    },
    delOtherImg(v){
      if (this.formData.otherFileList.length > 0) {
        this.formData.otherFileList.splice(v, 1)
      }
    },
    fileNameEvt(v) {
      this.fileName = v
    },
    dels(index) {
      if (this.formData.imgList.length > 0) {
        this.formData.imgList.splice(index, 1)
      }
    },
    // dealDisabledDate (time) {
    //   return time.getTime() < Date.now() - 8.64e7
    // },
    holdAreaChange(){
      this.getUnitNumOpiton()
      if(this.formData.holdAreaUnit == '公顷'){
        this.holdAreaNum = ((this.formData.holdArea * 1) * 15).toFixed(2)
      } else if(this.formData.holdAreaUnit == '平方千米'){
        this.holdAreaNum = ((this.formData.holdArea * 1) * 1500).toFixed(2)
      } else {
        this.holdAreaNum = ((this.formData.holdArea * 1) * 0.0015).toFixed(4)
      }
    },
     restMainPartInfo(){
      this.formData.mainPartIdentityName = ''  //企业名称/组织名称/姓名
      this.formData.mainPartCreditCode = '',  //统一信用代码
      this.formData.mainPartRegistAddrss = '',  //注册地址
      this.formData.mainPartLegalName = '',  //法定代表人
      this.formData.mainPartContactPerson = '' //联系人
      this.formData.mainPartContactNumber = ''  //联系电话
      this.formData.mainPartContactAddress = ''  //联系地址
      this.formData.mainPartIdNumber = ''  //身份证号  ;
       this.formData.transferType = '' //转让方类型
       this.formData.companyProperties = '' //企业性质
       this.formData.companyType = '' //企业类型
       this.formData.economicScale = '' //经济规模
       this.formData.companyIndustryCode = [] //所属行业
       this.formData.sourceFund = '' //资金来源
    },
    // 获取详情数据
    async getTableData() {
      await this.$api.my.applyDetail({applyId: this.$route.query.id,type: 2 }).then((res) => {
        if (res.code == 1000) {
          this.formData.circulWay = res.data.circulWay.value
          this.formData.objectName = res.data.objectName.value
          this.formData.ownershipType = res.data.ownershipType.value
          this.formData.propertychildtype = res.data.propertychildtype.value;
          if(this.formData.circulWay ==='CZ'){
            this.formData.transferPeriod = res.data.transferPeriod.value
            this.formData.czprice = res.data.czprice.value
            this.formData.rentFreePeriod = res.data.rentFreePeriod.value
            this.formData.zujindizengtype = res.data.zujindizengtype.value
          }
          //林木
          if(this.formData.propertychildtype==='0501'){
            this.formData.biaoditype = res.data.biaoditype.value
            this.formData.holdArea = res.data.holdArea.value
            this.formData.holdAreaUnit = res.data.holdAreaUnit.value
            this.formData.cunfangaddress = res.data.cunfangaddress.value
            this.formData.remark = res.data.remark.value
          }
          //活立木
          if(this.formData.propertychildtype==='0502'){
            this.formData.holdArea = res.data.holdArea.value
            this.formData.holdAreaUnit = res.data.holdAreaUnit.value
            this.formData.ldqy = res.data.ldqy.value
            this.formData.sl = res.data.sl.value
            this.formData.pjxj = res.data.pjxj.value
            this.formData.pjxg = res.data.pjxg.value
            this.formData.treeType = res.data.treeType.value
            this.formData.yjcl = res.data.yjcl.value
            this.formData.forestUnit = res.data.forestUnit.value
          }
          //原木
          if(this.formData.propertychildtype==='0503'){
            this.formData.treeType = res.data.treeType.value
            this.formData.holdArea = res.data.holdArea.value
            this.formData.holdAreaUnit = res.data.holdAreaUnit.value
          }
          //地上林产品
          if(this.formData.propertychildtype==='0504'){
            this.formData.lcplb = res.data.lcplb.value
            this.formData.holdArea = res.data.holdArea.value
            this.formData.holdAreaUnit = res.data.holdAreaUnit.value
            this.formData.treeType = res.data.treeType.value
            this.formData.yjcl = res.data.yjcl.value
            this.formData.forestUnit = res.data.forestUnit.value
          }
          //林地承包经营权
          if(this.formData.propertychildtype==='0505'){
            this.formData.holdArea = res.data.holdArea.value
            this.formData.holdAreaUnit = res.data.holdAreaUnit.value
            this.formData.ldyt = res.data.ldyt.value
            this.formData.sl = res.data.sl.value
            this.formData.pjxj = res.data.pjxj.value
            this.formData.pjxg = res.data.pjxg.value
            this.formData.lqqx = res.data.lqqx.value
            this.formData.treeType = res.data.treeType.value
          }
          //其他林产品
          if(this.formData.propertychildtype==='0506'){
            this.formData.lcplb = res.data.lcplb.value
            this.formData.holdArea = res.data.holdArea.value
            this.formData.holdAreaUnit = res.data.holdAreaUnit.value
          }
          this.formData.location = res.data.location.value
          const a = res.data.location.value.split('/')
          if(a.length>3){
            this.formData.address = a[0] + '/' + a[1] + '/' + a[2] + '/' + a[3] + '/' + a[4];
            this.formData.fullAddress = a[5];
          }else {
            this.formData.address = a[0] + '/' + a[1] + '/' + a[2];
            this.formData.fullAddress = a[3];
          }
          if(res.data.areaConfigId){this.formData.areaConfigId = res.data.areaConfigId}
          this.formData.reason = res.data.reason
          this.formData.name = res.data.name.value
          // if(res.data.forestAttr.value)this.formData.forestAttr = res.data.forestAttr.value + ''
          this.formData.tranferType = res.data.tranferType.value * 1
          this.formData.amount = res.data.amount.value
          this.formData.amountUnit = res.data.amountUnit.value
          this.formData.submitGoodsTime = res.data.submitGoodsTime.value
          this.formData.isAdvancePayment = res.data.isAdvancePayment.value * 1
          this.formData.advancePaymentAmount = res.data.advancePaymentAmount.value
          this.formData.isOtherRightsHolder = res.data.isOtherRightsHolder.value * 1
          this.formData.otherRightsHolder = res.data.otherRightsHolder.value
          this.formData.otherRightsContent = res.data.otherRightsContent.value
          // this.formData.forestStock = res.data.forestStock.value
          this.formData.imgList = res.data.imgList || [];
          this.formData.otherFileList = res.data.otherFileList
          this.roleFileList = res.data.fileList
          this.roleFileList.forEach(item=>{
              this.$set(item, 'status', false)
              this.$set(item, 'fileList', [])
              if(item.maxNumber == 1){
                item.fileList.push({
                  fileName: item.fileName,
                  fileUrl: item.fileUrl[0],
                  fileType: item.fileType
                })
              } else {
                item.fileUrl.forEach(i=>{
                    item.fileList.push({
                    fileName: item.fileName,
                    fileUrl: i,
                    fileType: item.fileType
                  })
                })
              }
              if (this.status != 0 ) {
                item.status = item.flag
              }
          })
          if (res.data.listingMainPart.identityType.value){
            this.leftBanner.splice(this.leftBanner.length-1, 0 ,'标的物所属主体信息' )
            this.formData.mainPartIdentityType = res.data.listingMainPart.identityType.value || ''
            this.formData.mainPartIdentityName = res.data.listingMainPart.name.value || ''
            this.formData.mainPartCreditCode =res.data.listingMainPart.creditCode.value || ''
            this.formData.mainPartRegistAddrss=res.data.listingMainPart.registAddrss.value || ''
            this.formData.mainPartLegalName=res.data.listingMainPart.legalName.value || ''
            this.formData.mainPartContactPerson=res.data.listingMainPart.contactPerson.value || ''
            this.formData.mainPartContactNumber= res.data.listingMainPart.contactNumber.value || ''
            this.formData.mainPartContactAddress=res.data.listingMainPart.contactAddress.value || ''
            this.formData.mainPartIdNumber=res.data.listingMainPart.idNumber.value || ''
            this.formData.transferType = res.data.listingMainPart.transferType.value|| ''
            this.formData.companyProperties = res.data.listingMainPart.companyProperties.value|| ''
            this.formData.companyType = res.data.listingMainPart.companyType.value|| ''
            this.formData.economicScale = res.data.listingMainPart.economicScale.value|| ''
            this.formData.companyIndustryCode = res.data.listingMainPart.companyIndustryCode.value?[res.data.listingMainPart.companyIndustryCode.value[0],res.data.listingMainPart.companyIndustryCode.value]:[]
            this.formData.sourceFund = res.data.listingMainPart.sourceFund.value|| ''
          }
          if(this.status == 2){
            this.formDataStatus.circulWay = res.data.circulWay.flag
            this.formDataStatus.objectName = res.data.objectName.flag
            this.formDataStatus.ownershipType = res.data.ownershipType.flag
            this.formDataStatus.propertychildtype = res.data.propertychildtype.flag
            this.formDataStatus.bidType = res.data.bidType.flag
            this.formDataStatus.listingPrice = res.data.listingPrice.flag
            this.formDataStatus.paymentMethod = res.data.paymentMethod.flag
            // this.formDataStatus.transferMethod = res.data.transferMethod.flag;
            this.formDataStatus.name = res.data.name.flag
            this.formDataStatus.location = res.data.location.flag
            // this.formDataStatus.forestAttr = res.data.forestAttr.flag
            this.formDataStatus.holdArea = res.data.holdArea.flag
            this.formDataStatus.treeType = res.data.treeType.flag
            this.formDataStatus.tranferType = res.data.tranferType.flag
            this.formDataStatus.amount = res.data.amount.flag
            this.formDataStatus.submitGoodsTime = res.data.submitGoodsTime.flag
            this.formDataStatus.isAdvancePayment = res.data.isAdvancePayment.flag
            this.formDataStatus.advancePaymentAmount = res.data.advancePaymentAmount.flag
            this.formDataStatus.isOtherRightsHolder = res.data.isOtherRightsHolder.flag
            this.formDataStatus.otherRightsHolder = res.data.otherRightsHolder.flag
            this.formDataStatus.otherRightsContent = res.data.otherRightsContent.flag
            // this.formDataStatus.forestStock = res.data.forestStock.flag
            this.formDataStatus.imgList = res.data.imgList.every((item, index, array) => { return item.flag == true})
            this.formDataStatus.mainPartIdentityType = res.data.listingMainPart.identityType.flag
            this.formDataStatus.mainPartIdentityName = res.data.listingMainPart.name.flag
            this.formDataStatus.mainPartCreditCode =res.data.listingMainPart.creditCode.flag
            this.formDataStatus.mainPartRegistAddrss=res.data.listingMainPart.registAddrss.flag
            this.formDataStatus.mainPartLegalName=res.data.listingMainPart.legalName.flag
            this.formDataStatus.mainPartContactPerson=res.data.listingMainPart.contactPerson.flag
            this.formDataStatus.mainPartContactNumber= res.data.listingMainPart.contactNumber.flag
            this.formDataStatus.mainPartContactAddress=res.data.listingMainPart.contactAddress.flag
            this.formDataStatus.mainPartIdNumber=res.data.listingMainPart.idNumber.flag
            this.formDataStatus.amountUnit=res.data.amountUnit.flag
            this.formDataStatus.transferType=res.data.listingMainPart.transferType.flag
            this.formDataStatus.companyProperties=res.data.listingMainPart.companyProperties.flag
            this.formDataStatus.companyType=res.data.listingMainPart.companyType.flag
            this.formDataStatus.economicScale=res.data.listingMainPart.economicScale.flag
            this.formDataStatus.companyIndustryCode=res.data.listingMainPart.companyIndustryCode.flag
            this.formDataStatus.sourceFund=res.data.listingMainPart.sourceFund.flag
            this.formDataStatus.holdAreaUnit = res.data.holdAreaUnit.flag
            if(this.formData.circulWay ==='CZ'){
              this.formDataStatus.transferPeriod = res.data.transferPeriod.flag
              this.formDataStatus.czprice = res.data.czprice.flag
              this.formDataStatus.rentFreePeriod = res.data.rentFreePeriod.flag
              this.formDataStatus.zujindizengtype = res.data.zujindizengtype.flag
            }
            //林木
            if(this.formData.propertychildtype==='0501'){
              this.formDataStatus.biaoditype = res.data.biaoditype.flag
              this.formDataStatus.holdArea = res.data.holdArea.flag
              this.formDataStatus.cunfangaddress = res.data.cunfangaddress.flag
              this.formDataStatus.remark = res.data.remark.flag
            }
            //活立木
            if(this.formData.propertychildtype==='0502'){
              this.formDataStatus.holdArea = res.data.holdArea.flag
              this.formDataStatus.ldqy = res.data.ldqy.flag
              this.formDataStatus.sl = res.data.sl.flag
              this.formDataStatus.pjxj = res.data.pjxj.flag
              this.formDataStatus.pjxg = res.data.pjxg.flag
              this.formDataStatus.treeType = res.data.treeType.flag
              this.formDataStatus.yjcl = res.data.yjcl.flag
              this.formDataStatus.forestUnit = res.data.forestUnit.flag
            }
            //原木
            if(this.formData.propertychildtype==='0503'){
              this.formDataStatus.treeType = res.data.treeType.flag
              this.formDataStatus.holdArea = res.data.holdArea.flag
            }
            //地上林产品
            if(this.formData.propertychildtype==='0504'){
              this.formDataStatus.lcplb = res.data.lcplb.flag
              this.formDataStatus.holdArea = res.data.holdArea.flag
              this.formDataStatus.treeType = res.data.treeType.flag
              this.formDataStatus.yjcl = res.data.yjcl.flag
              this.formDataStatus.forestUnit = res.data.forestUnit.flag
            }
            //林地承包经营权
            if(this.formData.propertychildtype==='0505'){
              this.formDataStatus.holdArea = res.data.holdArea.flag
              this.formDataStatus.ldyt = res.data.ldyt.flag
              this.formDataStatus.sl = res.data.sl.flag
              this.formDataStatus.pjxj = res.data.pjxj.flag
              this.formDataStatus.pjxg = res.data.pjxg.flag
              this.formDataStatus.lqqx = res.data.lqqx.flag
              this.formDataStatus.treeType = res.data.treeType.flag
            }
            //其他林产品
            if(this.formData.propertychildtype==='0506'){
              this.formDataStatus.lcplb = res.data.lcplb.flag
              this.formDataStatus.holdArea = res.data.holdArea.flag
            }
          }
          this.formData.holdAreaUnit = res.data.holdAreaUnit.value || ''
          this.holdAreaChange()
          this.formData.bidType = res.data.bidType.value;
          this.formData.listingPrice = res.data.listingPrice.value;
          this.formData.unitTime = res.data.unitTime.value;
          this.formData.paymentMethod = res.data.paymentMethod.value;
          // this.formData.transferMethod = res.data.transferMethod.value;
          this.formData.unitNum = res.data.unitNum.value;
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {}).finally(()=>{
        this.Loading = false;
      })
    },
    tranferTypeChange(v){
      this.formData.amount = ''
    },
    statusCheck(v) {
      switch (v) {
        case '0':
          return '已保存'
          break
        case '1':
          return '审批中'
          break
        case '2':
          return '未通过'
          break
        case '3':
          return '挂牌中'
          break
        case '4':
          return '已摘牌'
          break
        case '5':
          return '未成交'
          break
        case '6':
          return '已成交'
          break
        case '7':
          return '已终止'
          break
        case '8':
          return '主动摘牌'
          break
        case '9':
          return '中止审核中'
          break
        case '10':
          return '竞价结束'
          break
        default:
          return ''
          break
      }
    },
    leftBannerEvt(item, index) {
      var el = document.getElementById(index);
      this.chooseIndex = index
      if (index != 0) {
        this.$nextTick(function() {
          window.scrollTo({ behavior: "smooth", top: el.offsetTop });
        });
      }
    },
    checkFileAddr(list){
      return list && list.every(item => {
        if (item.isRequire && !item.fileUrl[0]) {
          this.$message.error(`请将《${item.fileName}》的相关资料上传完善`);
          return false
        } else {
          return true
        }
      })
    },
    save(){
      this.Loading = true
      let directionalFinancingFiles = []
      this.roleFileList.forEach(item =>{
        const obj = {
          appendixType: item.appendixType,
          fileName: item.fileName,
          fileUrl: [],
          fileType: item.fileType,
          canDownload: item.canDownload,
          downloadUrl: item.downloadUrl,
          maxNumber: item.maxNumber,
          isRequire: item.isRequire,
          id: item.id,
        }
        if(item.maxNumber == 1 && item.fileList[0]){
          obj.fileUrl.push(item.fileList[0].fileUrl || '')
        } else {
          item.fileList.forEach(i =>{obj.fileUrl.push(i.fileUrl || '')})
        }
        directionalFinancingFiles.push(obj)
      })
      this.formData.fileList = directionalFinancingFiles
      this.formData.listingMainPart.identityType = this.formData.mainPartIdentityType
      this.formData.listingMainPart.name = this.formData.mainPartIdentityName
      this.formData.listingMainPart.creditCode = this.formData.mainPartCreditCode
      this.formData.listingMainPart.registAddrss = this.formData.mainPartRegistAddrss
      this.formData.listingMainPart.legalName = this.formData.mainPartLegalName
      this.formData.listingMainPart.contactPerson = this.formData.mainPartContactPerson
      this.formData.listingMainPart.contactNumber = this.formData.mainPartContactNumber
      this.formData.listingMainPart.contactAddress = this.formData.mainPartContactAddress
      this.formData.listingMainPart.idNumber = this.formData.mainPartIdNumber
      this.formData.listingMainPart.transferType = this.formData.transferType
      this.formData.listingMainPart.companyProperties = this.formData.companyProperties
      this.formData.listingMainPart.companyType = this.formData.companyType
      this.formData.listingMainPart.economicScale = this.formData.economicScale
      if(this.formData.mainPartIdentityType=='01'){
        this.formData.listingMainPart.companyIndustryCode = this.formData.companyIndustryCode[1]
      }
      this.formData.listingMainPart.sourceFund = this.formData.sourceFund
      this.formData.zlqx = this.formData.transferPeriod  //租赁期限   默认取“流转期限”不给输入
      this.formData.zftype = this.formData.paymentMethod  //租金支付方式    默认取“付款方式”不给输入
      //林木
      if(this.formData.propertychildtype==='0501'){
        this.formData.biaodiname = this.formData.objectName
        this.formData.propertyprice = this.formData.listingPrice
      }
      //原木
      if(this.formData.propertychildtype==='0503'){
        this.formData.yjcl = this.formData.holdArea
        this.formData.forestUnit = this.$refs.logRef.selectedLabel
      }
      //其他林产品
      if(this.formData.propertychildtype==='0506'){
        this.formData.yjcl = this.formData.holdArea
      }
      this.formData.location = this.formData.address + "/"+ this.formData.fullAddress
      const a = this.formData.address.split('/')
      this.$set(this.formData,'province', a[0])
      this.$set(this.formData,'city', a[1])
      this.$set(this.formData,'county',a[2])
      if(a.length>3){
        this.$set(this.formData, 'township', a[3])
        this.$set(this.formData, 'village', a[4])
      }
      this.$api.my.saveForest(this.formData).then((res) => {
        if (res.code == 1000) {
          this.$message.success('保存成功')
          setTimeout(() => {
            this.$router.push({ name: 'MyApplyList'})
          },1500)
        }
      }).catch((error) => {}).finally(()=>{
        this.Loading = false;
      })
    },
    sumbitEvt(){
      this.$refs.formRef.validate(v => {
        if (v) {
          if(this.formData.bidType==1){
            if((!this.formData.unitNum&&!this.formData.unitTime)||(this.formData.unitNum==='无'&&this.formData.unitTime==='0')||
                (!this.formData.unitNum&&this.formData.unitTime==='0')||(this.formData.unitNum==='无'&&!this.formData.unitTime)){
              return this.$message.error(`${this.formData.tranferType == 1 ? '起拍价格' : '标的价格'}数量单位与时间单位，至少填写一个`)
            }
          }
          // if (this.status == 0 && this.agreementName && !this.checkAgree) return this.$message.error(`请阅读并勾选《${this.agreementName}》`);
          let directionalFinancingFiles = []
          this.roleFileList.forEach(item =>{
            const obj = {
              appendixType: item.appendixType,
              fileName: item.fileName,
              fileUrl: [],
              fileType: item.fileType,
              canDownload: item.canDownload,
              downloadUrl: item.downloadUrl,
              maxNumber: item.maxNumber,
              isRequire: item.isRequire,
              id: item.id,
            }
            if(item.maxNumber == 1 && item.fileList[0]){
              obj.fileUrl.push(item.fileList[0].fileUrl || '')
            } else {
              item.fileList.forEach(i =>{obj.fileUrl.push(i.fileUrl || '')})
            }
            directionalFinancingFiles.push(obj)
          })
          const check = this.checkFileAddr(directionalFinancingFiles)
          if(check){
            this.$confirm('确认提交?', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.Loading = true
              this.formData.fileList = directionalFinancingFiles
              this.formData.listingMainPart.identityType = this.formData.mainPartIdentityType
              this.formData.listingMainPart.name = this.formData.mainPartIdentityName
              this.formData.listingMainPart.creditCode = this.formData.mainPartCreditCode
              this.formData.listingMainPart.registAddrss = this.formData.mainPartRegistAddrss
              this.formData.listingMainPart.legalName = this.formData.mainPartLegalName
              this.formData.listingMainPart.contactPerson = this.formData.mainPartContactPerson
              this.formData.listingMainPart.contactNumber = this.formData.mainPartContactNumber
              this.formData.listingMainPart.contactAddress = this.formData.mainPartContactAddress
              this.formData.listingMainPart.idNumber = this.formData.mainPartIdNumber
              this.formData.listingMainPart.transferType = this.formData.transferType
              this.formData.listingMainPart.companyProperties = this.formData.companyProperties
              this.formData.listingMainPart.companyType = this.formData.companyType
              this.formData.listingMainPart.economicScale = this.formData.economicScale
              if(this.formData.mainPartIdentityType=='01'){
                this.formData.listingMainPart.companyIndustryCode = this.formData.companyIndustryCode[1]
              }
              this.formData.listingMainPart.sourceFund = this.formData.sourceFund
              this.formData.zlqx = this.formData.transferPeriod  //租赁期限   默认取“流转期限”不给输入
              this.formData.zftype = this.formData.paymentMethod  //租金支付方式
              //林木
              if(this.formData.propertychildtype==='0501'){
                this.formData.biaodiname = this.formData.objectName
                this.formData.propertyprice = this.formData.listingPrice
              }
              //原木
              if(this.formData.propertychildtype==='0503'){
                this.formData.yjcl = this.formData.holdArea
                this.formData.forestUnit = this.$refs.logRef.selectedLabel
              }
              //其他林产品
              if(this.formData.propertychildtype==='0506'){
                this.formData.yjcl = this.formData.holdArea
              }
              this.formData.location = this.formData.address + "/"+ this.formData.fullAddress
              const a = this.formData.address.split('/')
              this.$set(this.formData,'province', a[0])
              this.$set(this.formData,'city', a[1])
              this.$set(this.formData,'county',a[2])
              if(a.length>3){
                this.$set(this.formData, 'township', a[3])
                this.$set(this.formData, 'village', a[4])
              }
              this.$api.my.forestSubmit(this.formData).then((res) => {
                if (res.code == 1000) {
                  this.$message.success('提交成功')
                  setTimeout(() => {
                    this.$router.push({ name: 'MyApplyList', query: {activeNumber: 3}})
                  },1500)
                }
              }).catch((error)=>{}).finally(()=>{
                setTimeout(() => {
                  this.Loading = false;
                }, 1400);
              })
            }).catch(() => {});
          }
        }
      })
    },
    changeCode(name) {
      this.$nextTick(() => {
        if(this.formData[`${name}`] != null){
         this.formData[`${name}`] = this.formData[`${name}`].replace(/[^\d.]/g,'')
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-container {
  width: auto;
  max-width: 1200px;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  .el-aside {
    div {
      background: #fff;
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: #3e4860;
      margin-bottom: 5px;
    }
    .active {
      background:url('~@/assets/navBarselected.png') no-repeat;
      color: #fff;
    }
  }
}

.main-block {
  width: auto;
  max-width: 1200px;
  margin: auto 10px;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 !important;
  .top-title {
    margin: 20px !important;
  }
  .status-wrap {
    height: 110px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.checkErrorBg {
      background: #fef0f2;
    }
    &.checkingBg {
      background: #fef9f0;
    }
    &.checkSuccessBg {
      background: #F0F9F0;
    }
    .left {
      display: flex;
      align-items: center;
      .status {
        margin-left: 35px;
        p {
          margin: 0;
          font-size: 20px;
          .errorFont {
            font-size: 16px;
            color: #60697e;
            padding-left: 15px;
          }
        }
      }
      .img-warp {
        width: 110px;
        height: 110px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.checking {
          background: #ffaa36;
        }
        &.checkSuccess {
          background: #91A442;
        }
        &.checkError {
          background: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
        }
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
    }

  }
  .h_bg {
    margin: 0 0 30px;
  }
  .redFont{
    color: #22C686;
  }
   /deep/ .formRelative{
     .el-form-item__content {
        position:static !important;
    }
  }
}
  .form {
    /deep/.actives {
      .el-form-item__label::before {
        content: '*';
        display: inline-block;
        vertical-align: middle;
        color: #f56c6c;
        margin-right: 4px;
        font-size: 20px;
      }
    }
  }
</style>
